import React, { useEffect } from 'react'
import { Box, Flex, Text } from '@chakra-ui/react'
import MessageStack from '../../../components/features/Wizard/MessageStack/MessageStack'
import { observer } from 'mobx-react'
import rootStore from '../../../store/RootStore'
import TreeView from '../../../components/features/Wizard/TreeView/TreeView'
import { useIssueSummaryQuery } from '../hooks/useIssueSummaryQuery'

const SetupSummary = observer(() => {
  const {
    wizardStore: { reportBlueprint, availableCharts, sourceId, setError },
  } = rootStore

  const issueSummary = useIssueSummaryQuery(sourceId)
  useEffect(() => {
    if (issueSummary.data?.issues?.length > 0) {
      setError(
        'There are issues with your report. Please fix them before continuing.',
      )
    }
  }, [issueSummary.data?.issues?.length, setError])
  return (
    <Flex>
      <Box
        flex={1}
        mr="32px">
        <TreeView
          reportBlueprint={reportBlueprint}
          availableCharts={availableCharts}
          readOnly
          rootId={sourceId}
        />
      </Box>
      <Box flex={1}>
        <Text
          textStyle="h3"
          mb="12px">
          Messages:
          {issueSummary.isLoading && 'Loading...'}
          {issueSummary.isError && 'Error'}
        </Text>
        <MessageStack issues={issueSummary.data?.issues} />
      </Box>
    </Flex>
  )
})

SetupSummary.propTypes = {}

export default SetupSummary
